import { render, staticRenderFns } from "./Ontslagbrief.vue?vue&type=template&id=0bd1bf77"
import script from "./Ontslagbrief.vue?vue&type=script&lang=js"
export * from "./Ontslagbrief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports